import { GoogleAnalyticsSingleID } from "../../../environments/GoogleAnalyticsIDs";

export function googleAnalyticsGtag (GoogleAnalyticsSingleID) {
  const scriptTag = document.createElement("script");
  scriptTag.type = "text/javascript";
  scriptTag.src = 'https://www.googletagmanager.com/gtag/js?id='+GoogleAnalyticsSingleID;
  scriptTag.async = true;
  document.body.appendChild(scriptTag);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = gtag; // Ensure global availability

  gtag('js', new Date());
  gtag('config', GoogleAnalyticsSingleID, { send_page_view: true });
  return true;
}

export default googleAnalyticsGtag
